import React from 'react';

import {Picture} from '@udemy/react-core-components';
import {tokens} from '@udemy/styles';

import styles from './messaging-banner.module.less';

import type {MessagingBannerVisual} from './messaging-banner.react-component';

const TABS_IMAGE_BASE_URL = `${process.env.ASSET_PREFIX}/staticx/udemy/images/marketplace/messaging-module`;

const MOBILE_MEDIA = `(max-width: ${tokens['breakpoint-sm-max']})`;

const AI_TABS_IMAGE_URL = `${TABS_IMAGE_BASE_URL}/ai_tabs_banner_graphic-v1.jpg`;

const PP_TABS_IMAGE_URL = `${TABS_IMAGE_BASE_URL}/pp_tabs_banner_graphic-v1.png`;
const PP_TABS_MOBILE_IMAGE_URL = `${TABS_IMAGE_BASE_URL}/pp_tabs_banner_graphic-mobile-v1.png`;

const CERTS_TABS_IMAGE_URL = `${TABS_IMAGE_BASE_URL}/certs_tabs_banner_graphic-v1.png`;

export const TABS_VISUAL_CONFIG: Record<string, MessagingBannerVisual> = {
    lihp_marketing_messaging_pp_upsell: {
        backgroundStyle: {
            backgroundImage:
                'radial-gradient(100% 100% at 0% 0%, #5022C3 30%, #6D28D2 50%, #892DE1 80%)',
        },
        endImageArea: (
            <Picture
                src={PP_TABS_IMAGE_URL}
                sources={[{srcSet: PP_TABS_MOBILE_IMAGE_URL, media: MOBILE_MEDIA}]}
                alt=""
                width="unset"
                height="unset"
                className={styles['image-fill']}
                imgClassName={styles.image}
            />
        ),
    },
    lihp_marketing_messaging_nav_ai: {
        backgroundStyle: {
            backgroundImage:
                'radial-gradient(103.23% 103.23% at 0% 0%, #6B2FC0 30%, #7B3BD0 50%, #853FD0 80%)',
        },
        endImageArea: (
            <Picture
                src={AI_TABS_IMAGE_URL}
                sources={[]}
                alt=""
                width="unset"
                height="unset"
                className={styles['image-fill']}
                imgClassName={styles.image}
            />
        ),
    },
    lihp_marketing_messaging_nav_certifications: {
        backgroundStyle: {
            backgroundImage:
                'radial-gradient(103.23% 103.23% at 0% 0%, #0E8390 30%, #45B5BB 50%, #97DFE3 80%)',
        },
        endImageArea: (
            <Picture
                src={CERTS_TABS_IMAGE_URL}
                sources={[]}
                alt=""
                width="unset"
                height="unset"
                className={styles['image-fill']}
                imgClassName={styles.image}
            />
        ),
    },
};
